module.exports = __webpack_public_path__ + "static/img/serviceBanner_m.4fb1e5bb.png";